import script from "./CsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CsPage.vue?vue&type=script&setup=true&lang=js"

import "./CsPage.vue?vue&type=style&index=0&id=6fd803ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd803ea"]])

export default __exports__